import { createFileRoute, redirect } from "@tanstack/react-router"
import { EmailVerifyPage } from "@/pages/profile/email-verify"

interface EmailVerifySearch {
	email?: string | undefined
}

export const Route = createFileRoute("/_authenticated/profile/email/verify")({
	component: EmailVerifyPage,
	validateSearch: (search): EmailVerifySearch => ({
		email: typeof search.email === "string" ? search.email : undefined,
	}),
	beforeLoad: ({ search }) => {
		if (!search.email) throw redirect({ to: "/profile/email/send" })
		return { email: search.email }
	},
})
